import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { selectedWidget, Tab, workareaSize } from 'src/core/types/workarea.types';
import { DeviceService } from 'src/core/services/device.service';
import { LoadingService } from 'src/core/services/loading.service';
import { SelectedsystemService } from 'src/core/services/selectedsystem.service';
import { WidgetService } from 'src/core/services/widget.service';
import { AutocheckDetailsComponent } from '../instrument-details/autocheck-details/autocheck-details.component';
import { MsNotificationsComponent } from "../service-history-details/ms-notifications/ms-notifications.component";
import { DataService } from 'src/core/services/data.service';
import { SparePartsComponent } from '../service-history-details/spare-parts/spare-parts.component';
import { ActivitiesComponent } from '../service-history-details/activities/activities.component';
import { EscalationsComponent } from '../service-history-details/escalations/escalations.component';
import { ErrorsComponent } from '../instrument-details/errors/errors.component';
import { MaintenanceDetailsComponent } from '../instrument-details/maintenance-details/maintenance-details.component';
import { PsmDetailsComponent } from '../service-history-details/psm-details/psm-details.component';
import { SelectedSystem } from 'src/core/types/selectedSystem.types';
import { HttpClient } from '@angular/common/http';
import { AuthService } from 'src/core/services/auth.service';
import { SessionService } from 'src/core/services/session.service';
import { FunclocDetailsComponent } from '../funcloc-details/funcloc-details.component';
import { SelectedContentService } from 'src/core/services/selectedcontent.service';
import { filter } from 'rxjs';
import { UpcomingServicesDetailsComponent } from '../upcoming-services-details/upcoming-services-details.component';
import { SelectedSiteService } from 'src/core/services/selectedsite.service';
import { BookmarkMenuComponent } from "src/app/bookmark-menu/bookmark-menu.component";
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-work-area',
  imports: [CommonModule, AutocheckDetailsComponent, MsNotificationsComponent, SparePartsComponent, ActivitiesComponent, EscalationsComponent, ErrorsComponent, MaintenanceDetailsComponent, PsmDetailsComponent, FunclocDetailsComponent, UpcomingServicesDetailsComponent, BookmarkMenuComponent, TranslocoModule],
  templateUrl: './work-area.component.html',
  styleUrl: './work-area.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  host: {
    '[style.flex]': "workareaSize === 'fullscreen' ? '1 1 100%' : null",
  }
})
export class WorkAreaComponent {

  constructor(
    private loadingService: LoadingService,
    private selectedSystemService: SelectedsystemService,
    private selectedSiteService: SelectedSiteService,
    private widgetService: WidgetService,
    private deviceService: DeviceService,
    private dataService: DataService,
    private http: HttpClient,
    private authService: AuthService,
    private sessionService: SessionService,
    private selectedContentService: SelectedContentService
  ) {

  }

  isLoading: boolean;
  isError: boolean;
  deviceInformation: {};
  selectedWidget: selectedWidget = "None";
  workareaSize: workareaSize;
  screenInfo$ = this.deviceService.screenInfo$;
  activeTab: string = "Maintenance";
  selectedsystem: SelectedSystem;

  availableTabs: Tab[] = [
    { selectedWidget: "instrument", name: "Maintenance", labelKey: "workarea.tab.maintenance" },
    { selectedWidget: "instrument", name: "Autocheck", labelKey: "workarea.tab.autocheck" },
    { selectedWidget: "instrument", name: "Events", labelKey: "workarea.tab.events" },
    { selectedWidget: "service-history", name: "Notifications", labelKey: "workarea.tab.notifications" },
    { selectedWidget: "service-history", name: "Spare Parts Used", labelKey: "workarea.tab.sparePartsUsed" },
    { selectedWidget: "service-history", name: "Activities", labelKey: "workarea.tab.activities" },
    { selectedWidget: "service-history", name: "Proactive Alarms", labelKey: "workarea.tab.proactiveAlarms" },

  ];

  // { selectedWidget: "service-history", name: "Escalations" }

  displayedTabs: Tab[] = [];


  ngOnInit(): void {

    this.selectedContentService.selectedSystem$
      .pipe(filter((s): s is SelectedSystem => !!s))
      .subscribe((selectedSystem) => {
        this.selectedsystem = selectedSystem;
      });

    this.widgetService.$selectedWidget.subscribe({
      next: (widget: selectedWidget) => {
        this.selectedWidget = widget;
      }
    });

    this.widgetService.$workareaSize.subscribe({
      next: (size: workareaSize) => {
        this.workareaSize = size;
      }
    });

    this.widgetService.$activeTab.subscribe((tab) => {
      if (tab) {
        this.activeTab = tab;
        if (tab !== "") { this.trackTab(tab) };
      } else {
        this.activeTab = this.displayedTabs[0]?.name;
        if (tab !== "") { this.trackTab(this.displayedTabs[0]?.name) };
      }
    });

  }

  trackTab(tab) {

    const body = {
      consent: this.authService.userData.consented,
      device: this.deviceService.getDeviceType(),
      country: this.authService.userData.basic["country"],
      department: this.authService.userData.basic["department"],
      type: this.selectedContentService.selection.kind,
      serial: this.selectedContentService.selection.kind === "device" ? this.selectedContentService.currentSystem?.SerialNumber : null,
      material: this.selectedContentService.selection.kind === "device" ? this.selectedContentService.currentSystem?.MaterialNumber : null,
      siteId: this.selectedContentService.selection.kind === "site" ? this.selectedContentService.currentSite?.Id : null,
      attribute: "tab",
      value: tab,
      sessionid: this.sessionService.sessionId
    };

    this.http.put(`${window.location.protocol}//${window.location.hostname}${window.location.port !== "" ? ":" + "8080" : ""}/data/trackTab`, body).subscribe({
      next: (response) => {
        console.log('Tab tracked successfully:', response);
      },
      error: (error) => {
        console.error('There was an error!', error);
      }
    });
  }

  generateTitleIcon() {
    switch (this.selectedWidget) {
      case "service-history":
        return "utilities";
      case "service-metrics":
        return "kpi";
      case "instrument":
        return "open-tasks";
      case "site":
        return "pin";
      default:
        return "message-history";
    }
  }

  trackBySerial(index: number, item: any): string {
    return item?.SerialNumber + item?.MaterialNumber;
  }
}
